<template>
  <div>
    <toolbar/>
      <div class="containerFull">
        <headerbar/>
        <br>
        <form v-if="rule" v-on:submit.prevent="updateRule">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="rule-service">Serviço:</label>
              <input id="rule-service" class="form-control" v-model="rule.service.name" readonly>
            </div>
            <div class="form-group col-md-6">
              <label for="rule-enable">Status Serviço</label>
              <input id="rule-enable" class="form-control" v-model.boolean="rule.service.enabled ? 'Ativo' : 'Inativo'" readonly>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="rule-minRange">Faixa mínima:</label>
              <input
                type="number"
                id="rule-minRange"
                class="form-control"
                v-bind:title="`Faixa mínima: ${rule.minRange}`"
                v-model.number="rule.minRange" min="0" readonly>
                <div class="invalid-feedback">
                  A faixa mínima deve ser menor do que a faixa máxima!
                </div>
            </div>
            <div class="form-group col-md-6">
              <label for="rule-maxRange">Faixa máxima:</label>
              <input type="number"
                     id="rule-maxRange"
                     class="form-control"
                     v-bind:title="rule.maxRange ? rule.maxRange : '*'"
                     v-model.number="rule.maxRange" min="0" readonly>
                <div class="invalid-feedback">
                  A faixa máxima deve ser maior do que a faixa mínima!
                </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="rule-fixed-price">Métrica de precificação</label>
              <input id="rule-fixed-price" class="form-control" v-model.number="rule.fixedPrice ? 'Fixo' : transliterateService(rule)" readonly>
            </div>
            <div class="form-group col-md-6">
              <label for="rule-maxInstallment">Parcelamento Máximo</label>
              <select id="rule-maxInstallment" class="form-control" v-model.number="rule.maxInstallment">
                <option v-for="maxInstallment in maxInstallments" :value="maxInstallment">{{maxInstallment}}</option>
              </select>
            </div>
          </div>
          <div class="form-row" v-if="rule.plans && rule.plans.length > 0">
            <div  v-for="plan in rule.plans" class="form-group col-md-3">
              <label v-bind:for="`rule-plan-tax-${plan.name}`">Preço: {{plan.name.toUpperCase()}}</label>
              <input type="number" v-bind:id="`rule-plan-tax-${plan.name}`" step=any class="form-control" v-model.number="plan.value">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="rule-legalProposeTax">Preço: Finalidade Jurídica</label>
              <input type="number" id="rule-legalProposeTax" class="form-control" step=any v-model.number="rule.legalProposeTax">
            </div>
            <div class="form-group col-md-4">
              <label for="rule-languageTax">Preço: Idiomas ≠ PT</label>
              <input type="number" id="rule-languageTax" class="form-control" step=any v-model.number="rule.languageTax">
            </div>
            <div class="form-group col-md-4">
              <label for="rule-installmentTax">Preço: Parcelamento</label>
              <input type="number" id="rule-installmentTax" class="form-control" step=any v-model.number="rule.installmentTax">
            </div>
          </div>
          <div class="form-row" v-if="rule.plans && rule.plans.length > 0">
            <div  v-for="plan in rule.plans" class="form-group col-md-3">
              <label v-bind:for="`rule-plan-deadline-${plan.name}`">Prazo em dias: {{plan.name.toUpperCase()}}</label>
              <input type="number" v-bind:id="`rule-plan-deadline-${plan.name}`" class="form-control" v-model.number="plan.deadline">
            </div>
          </div>
          <button class="btn btn-primary">Salvar Alterações</button>
        </form>
        <br>
      </div>
    </div>
</template>
<script>
import Headerbar from '@/components/Nav/Headerbar';
import Toolbar from '@/components/Nav/Toolbar';

export default {
  name: 'dashboard-rule-form',
  props: {
    ruls: {
      maxInstallment: String,
      legalProposeTax: Number,
    },
  },
  data() {
    return {
      rule: null,
      maxInstallments: Array.from({ length: 12 }, (v, i) => i).map(n => n+1),
      minRange: null,
      maxRange: null,
    };
  },
  async created() {
    await this.fetchService();
    await this.fetchRuleById(this.$route.params.id);
  },
  methods: {
    async fetchRuleById(id) {
      const rule = await this.$store.dispatch('rule/getRuleById', id);
      if (rule) {
        this.rule = rule;
        this.minRange = rule.minRange;
        this.maxRange = rule.maxRange;
      }
    },
    async fetchService() {
      await this.$store.dispatch('service/fetchServices');
    },
    transliterateService(rule) {
      return rule.fixedPrice ? 'Fixo' : `Por ${this.transliterateServiceMetric(rule.service.metric)}`;
    },
    async updateRule(e) {
      const {installmentTax, languageTax, legalProposeTax, maxInstallment, plans} = this.rule;
      const data = {installmentTax, languageTax, legalProposeTax, maxInstallment, plans};
      const rule = await this.$store.dispatch('rule/updateRuleById', Object.assign(data, {ruleId: this.rule._id}));
      if (rule) {
        this.$swal({
          type: 'success',
          title: '(:',
          text: 'Regra atualizada com sucesso!',
          confirmButtonText: 'Ok',
        });
      } else {
        this.$swal({
          type: 'error',
          title: ':/',
          text: 'Ops, esta regra não pode ser atualizada!',
          confirmButtonText: 'Ok',
        });
      }
      return e.preventDefault();
    },
    checkServiceRange(e) {
      if (this.rule.maxRange && this.rule.minRange >= this.rule.maxRange) {
        e.target.classList.add('is-invalid');
        this.rule.minRange = this.minRange;
        this.rule.maxRange = this.maxRange;
        e.target.focus();
        return e.preventDefault();
      } else {
        e.target.classList.remove('is-invalid');
      }
      // Save history values
      this.minRange = this.rule.minRange;
      this.maxRange = this.rule.maxRange;
      return true;
    },
  },
  computed: {
    services() {
      return this.$store.state.service.services || [];
    },
  },
  components: {
    Toolbar,
    Headerbar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Rules/RuleForm.vue